import {
  AutoCompleteSearchRequest,
  AutoCompleteSearchResult,
  OptionItem,
} from "../models/control";
import { resolveAutoCompletePageSize } from "./mode-resolver";
import {
  AutoCompleteMetaDataLike,
  LegacyAutoCompleteSearchFunc,
  PagedAutoCompleteSearchFunc,
} from "./types";

type CreateLegacyToPagedSearchAdapterParams = {
  legacySearchFunc?: LegacyAutoCompleteSearchFunc;
  pagedSearchFunc?: PagedAutoCompleteSearchFunc;
  pageSize?: number;
};

const toPagedResult = (
  items: OptionItem[],
  request: AutoCompleteSearchRequest,
): AutoCompleteSearchResult => {
  const skipCount = request.pageIndex * request.pageSize;
  return {
    items: items.slice(skipCount, skipCount + request.pageSize),
    totalCount: items.length,
  };
};

const createLegacyToPagedSearchAdapter = ({
  legacySearchFunc,
  pagedSearchFunc,
  pageSize,
}: CreateLegacyToPagedSearchAdapterParams): PagedAutoCompleteSearchFunc => {
  const normalizedPageSize = resolveAutoCompletePageSize(pageSize);

  return async (keyword, request) => {
    if (pagedSearchFunc) {
      return pagedSearchFunc(keyword, request);
    }

    const normalizedRequest: AutoCompleteSearchRequest = {
      pageIndex: request.pageIndex,
      pageSize: request.pageSize > 0 ? request.pageSize : normalizedPageSize,
    };

    const items = (await legacySearchFunc?.(keyword)) || [];
    return toPagedResult(items, normalizedRequest);
  };
};

export const createPagedSearchAdapterByMetaData = (
  metaData: AutoCompleteMetaDataLike,
): PagedAutoCompleteSearchFunc => {
  return createLegacyToPagedSearchAdapter({
    legacySearchFunc: metaData?.searchOptionItemsAsync,
    pagedSearchFunc: metaData?.searchOptionItemsPagedAsync,
    pageSize: metaData?.autoCompletePageSize,
  });
};
